import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['visibilityToggleable', 'visibilityToggle']

  declare readonly visibilityToggleableTargets: HTMLElement[]
  declare readonly visibilityToggleTarget: HTMLElement
  declare readonly hasVisibilityToggleTarget: boolean

  connect (): void {
    this.element.addEventListener('visibility-toggle', _event => {
      this.changeSelfVisibility()
    })
  }

  changeSelfVisibility (): void {
    const classList = this.element.classList

    if (classList.contains('hidden')) {
      classList.remove('hidden')
    } else {
      classList.add('hidden')
    }
  }

  changeTargetVisibility ({ params: { rotateNumber = 180 } }: { params: { rotateNumber: number } }): void {
    this.visibilityToggleableTargets.forEach((target: HTMLElement) => { target.classList.toggle('hidden') })

    if (this.hasVisibilityToggleTarget) {
      this.visibilityToggleTarget.classList.toggle(`rotate-${rotateNumber}`)
    }
  }
}
